// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class PubDateSliderController {
   $scope: any
   dateRange: DateRangeService
   translationService: any
   searchScopeService: SearchScopeService
   constructor($scope: any, dateRange: DateRangeService, translationService: any, searchScopeService: SearchScopeService) {
      this.setSelection = this.setSelection.bind(this)
      this.retrieveSince = this.retrieveSince.bind(this)
      this.toggleBtnDatepicker = this.toggleBtnDatepicker.bind(this)
      this.$scope = $scope
      this.dateRange = dateRange
      this.translationService = translationService
      this.searchScopeService = searchScopeService
      this.$scope.range = this.dateRange.range
      this.$scope.selection = this.dateRange.selection
      this.$scope.setSelection = this.setSelection
      this.$scope.retrieveSince = this.retrieveSince
      this.$scope.toggleBtnDatepicker = this.toggleBtnDatepicker
      this.$scope.datePresets = this.dateRange.defaultPresets
      this.$scope.datePresetLabels = this.dateRange.datePresetLabels
      this.$scope.i18n = this.translationService
      this.$scope.facetDatepicker = this.dateRange.facetDatepicker
   }

   setSelection(attr: any) {
      this.dateRange.setSelection({
         start: attr.start,
         end: attr.end,
         selectedYears: attr.selectedYears
      })
      this.dateRange.applySelection()
   }

   retrieveSince(years: any, $event: any) {
      const retrieveSinceCallback = (goBackToSearchScope = false) => {
         if(!goBackToSearchScope){
            this.setSelection(this.dateRange.retrieveSince(years))
            this.dateRange.applySelection()
         }
      }
      $event.preventDefault()
      if(this.dateRange.searchScopeDateIsApplied()){
         this.searchScopeService.clearScopeAsSideEffect( '', retrieveSinceCallback)
      } else {
         retrieveSinceCallback()
      }
      
   }

   toggleBtnDatepicker() {
      return this.dateRange.toggleBtnDatepicker()
   }
}

PubDateSliderController.$inject = ['$scope', 'dateRangeService', 'translationService', 'searchScopeService']

angular.module('summonApp.controllers').controller('PubDateSliderCtrl', PubDateSliderController)
